import { render, staticRenderFns } from "./CounterInfo.vue?vue&type=template&id=131ab3ea&scoped=true&"
import script from "./CounterInfo.vue?vue&type=script&lang=js&"
export * from "./CounterInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131ab3ea",
  null
  
)

export default component.exports